import { render, staticRenderFns } from "./trade-table.vue?vue&type=template&id=a9c57866&"
import script from "./trade-table.vue?vue&type=script&lang=js&"
export * from "./trade-table.vue?vue&type=script&lang=js&"
import style0 from "./trade-table.vue?vue&type=style&index=0&id=a9c57866&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports